
import { Component, Input } from '@angular/core';

export interface PairingsAlphaRow {
  id: string;
  playerName: string;
  groupLabel: string;
  teeLabel: string;
  teeTimeDisplay: string;
  waveLabel: string | null;
  blockLabel: string | null;
  classification: string | null;
}

@Component({
  selector: 'app-pairings-alpha-list',
  standalone: true,
  imports: [],
  templateUrl: './pairings-alpha-list.component.html',
  styleUrls: ['./pairings-alpha-list.component.scss']
})
export class PairingsAlphaListComponent {
  @Input() players: PairingsAlphaRow[] = [];
  @Input() hasBlocks = false;
  @Input() isLoading = false;

  get showWaveColumn(): boolean {
    return this.players.some(player => !!player.waveLabel);
  }

  get showBlockColumn(): boolean {
    return this.players.some(player => !!player.blockLabel);
  }
}
